import React from "react";
import { ButtonStyled } from "@nike/nike-design-system-components";

function AssignButtonPanel({ disabled, onAssign, title }) {
  return (
    <div className="pg-assign-rail" aria-label="Assign pallet groups to spur">
      <ButtonStyled
        appearance="primary"
        type="button"
        className="pg-btn-apply pg-assign-btn"
        disabled={disabled}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!disabled) {
            onAssign?.();
          }
        }}
        title={title}
      >
        Assign &raquo;
      </ButtonStyled>
    </div>
  );
}

export default AssignButtonPanel;
